import { AuditRoleStatus } from "PFApp/audit_planner/parts/audit_role_status/audit_role_status";
import { useDetailsPanelContext } from "PFApp/booking/components/details_panel";
import RolePill from "PFApp/components/pills/role_pill";
import { ProjectItem } from "PFCore/hooks/queries/bookings/projects/use_projects_entries";
import { useDateFormatter } from "PFCore/hooks/use_date_formatter";
import React from "react";

import css from "./bars.module.scss";
import BasicBar from "./basic_bar";

interface RoleBarProps {
  left: number;
  top: number;
  width: number;
  start: string;
  end: string;
  original: ProjectItem;
  state: string;
}

export const RoleBar = ({ left, top, width, start, end, original, state }: RoleBarProps) => {
  const { detailsData, openDetailsPanel, closeDetailsPanel } = useDetailsPanelContext();

  const { utc, formatDate } = useDateFormatter();

  const handleClick = () => {
    if (detailsData?.id === original.activity.id) {
      closeDetailsPanel();
    } else {
      openDetailsPanel({ id: original.activity.id, type: "role" });
    }
  };

  const tooltipContent = (
    <div className={css.tooltip}>
      <div className={css.title}>{original.activity.name}</div>
      <div>{`${formatDate(utc(start))} - ${formatDate(utc(end))}`}</div>
      <AuditRoleStatus className={css.badge} role={original.activity} />
    </div>
  );

  return (
    <BasicBar left={left} top={top} width={width} onClick={handleClick} tooltipContent={tooltipContent}>
      <RolePill state={state} />
    </BasicBar>
  );
};
